import { render } from "./CheckField.vue?vue&type=template&id=32f39215"
import script from "./CheckField.vue?vue&type=script&lang=js"
export * from "./CheckField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__